const elevation = {
  // 100: '0 0 2px 0 rgba(0, 0, 0, .12), 0 2px 2px 0 rgba(0, 0, 0, .12)',
  // 200: '0 2px 4px 0 rgba(0, 0, 0, .71)',
  // 300: '0 1px 10px 0 rgba(0, 0, 0, .5)',
  0: 'none',
  100: '0 0 2px 0 rgba(0, 0, 0, .12)',
  200: '0 0 2px 0 rgba(0, 0, 0, .12), 0 2px 2px 0 rgba(0, 0, 0, .12)',
  250: '0 4px 8px 0 rgba(0, 0, 0, .08)',
  300: '0 0 2px 0 rgba(0, 0, 0, .12), 0 2px 2px 0 rgba(0, 0, 0, .12), 0 1px 3px 0 rgba(0, 0, 0, .14)',
  400: '0 2px 4px 0 rgba(0, 0, 0, .10), 0 3px 4px 0 rgba(0, 0, 0, .12), 0 1px 5px 0 rgba(0, 0, 0, .14)',
  500: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  chat: '0px 4px 20px rgba(0, 0, 0, 0.25)',
  button: '0px 3px 10px rgba(42, 115, 156, 0.15)',
  card: '0px 7px 15px 0px rgba(42, 115, 156, 0.25)',
  cardHover: '0px 7px 15px 0px rgba(42, 115, 156, 0.35)',
  // 500: '0px 5px 10px rgba(0, 0, 0, 0.1)',
  // 600: '0 12px 24px 0 rgba(16, 16, 16, 0.5)',
  // 600: '0 2px 4px 0 rgba(0, 0, 0, .10), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .14)',
  // 700: '0 6px 10px 0 rgba(0, 0, 0, .10), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px 0 rgba(0, 0, 0, .14)',
  // 800: '0 8px 10px 1px rgba(0, 0, 0, .10), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 5px 0 rgba(0, 0, 0, .14)',
  // 900: '0 12px 17px 2px rgba(0, 0, 0, .10), 0 5px 22px 4px rgba(0, 0, 0, .12), 0 7px 8px 0 rgba(0, 0, 0, .14)',
  // 1000: '0 16px 24px 2px rgba(0, 0, 0, .10), 0 6px 30px 5px rgba(0, 0, 0, .12), 0 8px 10px 0 rgba(0, 0, 0, .14)',
}

export default elevation
